export default class ReloadLayerUtil {
    static forceReloadLayer = (layer: any) => {
        layer.params.forceReload = 1 + Math.random() * (100 - 1);
    };
}
